import { getPayload } from 'helpers'
import { FormState } from 'typings'
import api from './requestBuilder'

const submitRequest = async (formValue: FormState, recaptchaToken: string, otpToken: string) => {
  const endpoint = '/v1/credit/accounts/ccpa/submitRequest'
  const payload = getPayload(formValue, recaptchaToken, otpToken)
  const response = await api.post(endpoint, payload)
  return response
}

export default submitRequest
